import { Audio } from 'expo-av';
import { BlurView } from 'expo-blur';
import { getFirestore, doc, setDoc, collection, addDoc } from 'firebase/firestore';
import moment from 'moment';
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Image, Pressable, Text, TextInput, View, ActivityIndicator, Alert, Platform } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

import buttonX from '../../assets/images/buttons/buttonX.png';

import { styles } from './styles';

const ScoreCard = ({
  finalScore,
  handleEnd,
  setRenderScore,
  setRenderRanking,
  setLastScoreId,
  time,
  onExitWithoutSave,
}) => {
  const { width, height } = useSafeAreaFrame();
  const db = getFirestore();

  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState('');

  const handleKeyPress = (char) => {
    if (char === 'backspace') {
      setInput((prev) => prev.slice(0, -1));
    } else if (char === 'space') {
      setInput((prev) => prev + ' ');
    } else {
      setInput((prev) => prev + char);
    }
  };

  const keyboardLayout = [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
    ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  ];

  const handleSubmit = useCallback(async () => {
    if (input !== '') {
      setLoading(true);

      const objectRef = doc(collection(db, 'scores'));

      const newObject = {
        name: input,
        score: finalScore,
        timeLeft: time,
        createdAt: moment().format(),
        id: objectRef.id,
      };

      await setDoc(objectRef, newObject);

      setLoading(false);

      handleEnd();

      setLastScoreId(objectRef.id);
      setRenderScore(false);
      setRenderRanking(true);
    } else {
      Alert.alert('Insira um nome');
    }
  }, [input]);

  return (
    <View style={{ position: 'absolute' }}>
      <BlurView
        style={{
          height,
          width,
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <View style={styles.container}>
          <Pressable
            onPress={() => {
              if (onExitWithoutSave) {
                onExitWithoutSave();
              }
              handleEnd();
              setRenderScore(false);
            }}
            style={{
              position: 'absolute',
              right: 0,
              flexDirection: 'row',
              top: -75,
              borderRadius: 50,
              backgroundColor: 'white',
              justifyContent: 'space-evenly',
              paddingLeft: 14,
              paddingRight: 8,
              paddingVertical: 8,
            }}>
            <Text
              style={{
                color: '#BF5540',
                fontFamily: 'Montserrat_400Regular',
                fontSize: 18,
                marginRight: 14,
              }}>
              Sair sem salvar
            </Text>
            <Image style={{ height: 24, width: 24 }} source={buttonX} />
          </Pressable>
          <Text style={[styles.title, { marginBottom: 40 }]}>Fim de jogo!</Text>

          <Text style={[styles.description, { marginBottom: 5 }]}>Sua pontuação final foi:</Text>
          <Text style={[styles.title, { marginBottom: 30, fontSize: 45 }]}>{finalScore}</Text>

          <Text style={[styles.description, { marginBottom: 15 }]}>
            Digite seu nome para salvar no ranking
          </Text>
          <TextInput 
            value={input} 
            onChangeText={setInput}
            style={styles.input}
            placeholder="Digite seu nome"
            showSoftInputOnFocus={false}
          />
          <Pressable
            onPress={() => {
              if (!loading) {
                handleSubmit();
              }
            }}
            style={styles.buttonBack}>
            {loading ? (
              <ActivityIndicator size="large" color="white" />
            ) : (
              <Text style={styles.textBack}>Salvar</Text>
            )}
          </Pressable>
        </View>

        {/* Custom Touchscreen Keyboard */}
        <View 
          style={{
            backgroundColor: '#f0f0f0',
            borderRadius: 15,
            padding: 15,
            width: '90%',
            marginTop: 20,
          }}>
          {keyboardLayout.map((row, rowIndex) => (
            <View 
              key={rowIndex}
              style={{
                flexDirection: 'row',
                justifyContent: 'center',
                marginBottom: 8,
              }}>
              {row.map((char) => (
                <Pressable
                  key={char}
                  onPress={() => handleKeyPress(char)}
                  style={{
                    backgroundColor: 'white',
                    padding: 12,
                    margin: 3,
                    borderRadius: 8,
                    minWidth: 40,
                    alignItems: 'center',
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.1,
                    shadowRadius: 3,
                    elevation: 3,
                  }}>
                  <Text style={{ fontSize: 18, fontWeight: 'bold' }}>{char}</Text>
                </Pressable>
              ))}
            </View>
          ))}
          
          {/* Special keys row */}
          <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 5 }}>
            <Pressable
              onPress={() => handleKeyPress('space')}
              style={{
                backgroundColor: 'white',
                padding: 12,
                margin: 3,
                borderRadius: 8,
                flex: 3,
                alignItems: 'center',
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 3,
                elevation: 3,
              }}>
              <Text style={{ fontSize: 14, fontWeight: 'bold' }}>ESPAÇO</Text>
            </Pressable>
            <Pressable
              onPress={() => handleKeyPress('backspace')}
              style={{
                backgroundColor: '#BF5540',
                padding: 12,
                margin: 3,
                borderRadius: 8,
                flex: 2,
                alignItems: 'center',
                shadowColor: '#000',
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.1,
                shadowRadius: 3,
                elevation: 3,
              }}>
              <Text style={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>←</Text>
            </Pressable>
          </View>
        </View>
      </BlurView>
    </View>
  );
};

export default ScoreCard;
